import { Formik } from 'formik';
import { CheckboxCard, SectionLegend, StepShell } from 'components/Profile';
import { getInitialValues, validationSchema, timePreferences, reachingMethods } from './helper'
import { blueCheckboxCardClass, blueCheckboxClass } from 'components/Profile/helper';
import { ProfileActions } from 'store/actions';
import { connect } from 'react-redux'
import toast from 'react-hot-toast';
import { useOutletContext } from 'react-router-dom';

let enhancer = connect(null, { ...ProfileActions })

const Form = ({ updatePreferences }) => {
  const { sectionData, mergeSection, goToNextStep }: any = useOutletContext();
  const initialData = sectionData.preferences;

  const handleSubmit = async (values) => {
    try {
      const { data } = await updatePreferences({ patient_setting: values });

      toast.success('Preferences saved successfully');
      mergeSection('preferences', data);
      goToNextStep('preferences');

    } catch (error) {
      toast.error(error.errors || 'Failed to save preferences. Please try again later.');
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={getInitialValues(initialData)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <StepShell stepId="preferences" isSubmitting={isSubmitting}>
          <SectionLegend optional description="Pick any that work for you, or leave blank if you're flexible.">Appointment time preference</SectionLegend>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
            {timePreferences.map(({ title, label }) => (
              <CheckboxCard
                key={`appointment-preference-${title}`}
                name={`appointment_preferences.${title}`}
                label={label}
                className={blueCheckboxCardClass}
                checkboxClassName={blueCheckboxClass}
              />
            ))}
          </div>

          <SectionLegend optional description="Leave blank and we won't send reminders — you'll still see everything in your portal.">How should we reach you?</SectionLegend>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-5">
            {reachingMethods.map(({ title, label }) => (
              <CheckboxCard
                key={`contact-preference-${title}`}
                name={`contact_preferences.${title}`}
                label={label}
                className={blueCheckboxCardClass}
                checkboxClassName={blueCheckboxClass}
              />
            ))}
          </div>
        </StepShell>
      )}
    </Formik>
  )
}

export default enhancer(Form);
